import { readFromWriteDBHTTPHeaderManager } from './readFromWriteDBHeaderManager';

export * from '@ts-gql/apollo';
export * from '@ts-gql/tag';
export type { NormalizedCacheObject } from '@apollo/client';
export { ApolloClient, ApolloError } from '@apollo/client';
export { HandleAuthErrorResponseLink } from './HandleAuthErrorResponseLink';
export { AnnotateRequestHeadersLink } from './AnnotateRequestHeadersLink';
export { AnnotateRequestHeaderWithCorrelationIdLink } from './AnnotateRequestHeaderWithCorrelationIdLink';
export { createCorrelationIdHeader } from './AnnotateRequestHeaderWithCorrelationIdLink';
export { createReckonStackVersionHeader } from './AnnotateRequestHeaderWithReckonStackVersion';
export { createOpenCollegesFeatureHeader } from './AnnotateRequestHeaderWithOpenCollegesFeature';
export { createPrefixLink } from './PrefixLink';
export { MockedGqlApiClientProvider } from './MockedGqlApiClientProvider';
export { GqlApiClientProvider } from './GqlApiClientProvider';
export { gqlApiClientProviderEvents } from './GQLApiClientProviderEvents';
export type { GqlApiClientProviderProps } from './GqlApiClientProvider';

export type { TokenRefreshHandler } from './GqlApiClientProvider';

export {
  useWriteCreateMutationResponseToCache,
  createMutationResponseCacheWriter,
} from './useWriteCreateMutationResponseToCache';
export type {
  useWriteCreateMutationResponseToCacheProps,
  QueryHavingItsCacheUpdated,
} from './useWriteCreateMutationResponseToCache';

export { queryResponse, nodeQueryResponse } from './queryResponse';
export { assertTypeName } from './assertTypeName';
export {
  getErrorCodes,
  getErrorCodesFromException,
  hasUnignorableErrorCodes,
  flattenErrorCodedMessage,
  hasWarningErrorCodes,
  isErrorObject,
  isSpecificErrorObject,
  hasAnyErrorCode,
  useErrorCodes,
  createErrorCodeExtractor,
  createMutationErrorCodesHook,
  createUknownErrorCodeExtractor,
  createMockErrorCodeFactory,
  mockErrorObject,
} from './useErrorCodes';

export { useExtractMissingPermissionsFromGQLErrors } from './useExtractMissingPermissionsFromGQLErrors';

export type {
  ErrorCodes,
  ErrorMessage,
  ErrorObject,
  ErrorType,
  MutationErrorCodesResult,
} from './useErrorCodes';

export {
  mockGrapQLError,
  mockGraphQLErrors,
  mockR1Error,
  mockR1Response,
} from './useErrorCode.mocks';

export type { APITrace } from './types';

export const onReadFromWriteDBMutationsUpdated =
  readFromWriteDBHTTPHeaderManager.onReadFromWriteDBMutationsUpdated;
